module.exports = __webpack_public_path__ + "img/inter-v11-latin-700.bef32a3.svg";